<template>
  <div>
    <h1>Upload URL</h1>

    <v-text-field
      v-model="websiteUrl"
      placeholder="Enter website URL"
      label="URL"
      outlined
      dense
    ></v-text-field>

    <v-btn @click="scrapeWebsite" color="primary" dark>
      <span>Upload</span>
    </v-btn>

    <p>{{ rawData }}</p>

    <div v-if="rawData">
      <p>rawData</p>
    </div>
  </div>
</template>

<script>
import {
  getFunctions,
  httpsCallable,
  connectFunctionsEmulator,
} from "firebase/functions";

export default {
  name: "StrappUploadUrl",

  data() {
    return {
      websiteUrl: "",
      scrapedData: null,
      rawData: "",
    };
  },

  mounted() {},

  methods: {
    async scrapeListing() {
      try {
        const browser = await puppeteer.launch({ headless: "new" });
        const page = await browser.newPage();
        await page.goto(this.websiteUrl);

        // Wait for the page to load completely
        await page.waitForNavigation({ waitUntil: "networkidle0" });

        const image = await page.$eval(
          "img.xt7dq6l.xl1xv1r.x6ikm8r.x10wlt62.xh8yej3",
          (element) => element.getAttribute("src")
        );
        const title = await page.$eval(
          "span.x1lliihq.x6ikm8r.x10wlt62.x1n2onr6",
          (element) => element.textContent.trim()
        );
        const price = await page.$eval(
          "span.x193iq5w.xeuugli.x13faqbe.x1vvkbs.x1xmvt09.x1lliihq.x1s928wv.xhkezso.x1gmr53x.x1cpjm7i.x1fgarty.x1943h6x.xudqn12.x676frb.x1lkfr7t.x1lbecb7.x1s688f.xzsf02u",
          (element) => element.textContent.trim()
        );
        const listingUrl = await page.$eval(
          "a.x1i10hfl.xjbqb8w.x6umtig.x1b1mbwd.xaqea5y.xav7gou.x9f619.x1ypdohk.xt0psk2.xe8uvvx.xdj266r.x11i5rnm.xat24cr.x1mh8g0r.xexx8yu.x4uap5.x18d9i69.xkhd6sd.x16tdsg8.x1hl2dhg.xggy1nq.x1a2a7pz.x1heor9g.x1lku1pv",
          (element) => element.getAttribute("href")
        );
        const location = await page.$eval(
          "span.x1lliihq.x6ikm8r.x10wlt62.x1n2onr6.xlyipyv.xuxw1ft.x1j85h84",
          (element) => element.textContent.trim()
        );

        await browser.close();

        return { image, title, price, url: listingUrl, location };
      } catch (error) {
        console.error(error);
        throw new Error("Failed to scrape listing");
      }
    },
    scrapeWebsite() {
      const functions = getFunctions();
      connectFunctionsEmulator(functions, "localhost", 5001);

      const scrapeListing = httpsCallable(functions, "scrapeListing");

      scrapeListing({
        url: this.websiteUrl,
      }).then((result) => {
        // Read result of the Cloud Function.
        /** @type {any} */
        const data = result.data;
        this.rawData = result.data;
        this.loading = true;
        console.log("data", data);
      });
    },
    // async scrapeWebsite() {
    //   try {
    //     const response = await scrapeWebsiteCallable({ url: this.websiteUrl });

    //     this.scrapedData = response.data;
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped></style>
